// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { tableMixins } from '@/app/mixins/utils/table-mixins';

// Third Party libraries
import * as $ from 'jquery';

// Services
import OrdersService from '@/app/services/main/orders/orders-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'ModalOrderDetails',
	mixins: [
		tableMixins,
		toastMessageMixins
	],
	data() {
		return {
			isAPILoading: false,
			isActionAPILoading: false,
			// table
			theads: [
				{ name: 'Image', sortLabel: null, isDesc: false, style: null},
				{ name: 'Products', sortLabel: null, isDesc: false, style: null},
				{ name: 'Quantity', sortLabel: null, isDesc: false, style: null},
				{ name: 'Price', sortLabel: null, isDesc: false, style: null},
			],
			modalContent: {},
			orderDetails: null
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		openModal(data) {
			this.modalContent = data;
			this.resetData();
			this.getOrderDetails();
			$(this.$refs.modalOrderDetails).modal('show');
		},
		closeModal() {
			$(this.$refs.modalOrderDetails).modal('hide');
		},
		showDisapproveModal() {
			this.closeModal();
			this.$emit('showDisapproveModal', this.orderDetails);
		},
		submitApproval() {
			this.isActionAPILoading = true;

			OrdersService.putApproveCancelOrder(this.modalContent.id)
				.then(res => {
					const { SUCCESS_APPROVE_CANCELLATION, ERROR_APPROVE_CANCELLATION } = this.toastMessages.order();

					if (res.status === STATUS_CODES.SUCCESS) {
						this.showCustomSuccessToast(SUCCESS_APPROVE_CANCELLATION, '');
						this.closeModal();
						this.orderActioned();
					} else {
						this.showAPIErrorToast(ERROR_APPROVE_CANCELLATION, res);
					}

					this.isActionAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isActionAPILoading = false;
				});
		},
		resetData() {
			this.orderDetails = null;
		},
		getOrderDetails() {
			this.isAPILoading = true;
			OrdersService.getOrderById(this.modalContent.id)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.orderDetails = res.data;
					} else {
						this.showAPIErrorToast('Unable to get order data.', res);
					}

					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		orderActioned() {
			this.$emit('refreshTableContent');
		}
	}
}